import $filters, { Filter } from "@/data/filters.constants";
import { useEffect, useState } from "react";
import { useMobile } from "@/hooks/use-responsive";
import MobileSearchbar from "@/components/pages/home/components/searchbar/adaptive/mobile-searchbar";
import DesktopSearchbar from "@/components/pages/home/components/searchbar/adaptive/desktop-searchbar";

type SearchBarProps = {
  onSelectFilter: (category: Filter) => void;
  onSearch: (value: string) => void;
  filters: Filter[];
  onSelectGender: (gender?: Filter) => void;
  scrollY?: number;
};

export type AdaptiveSearchBarProps = SearchBarProps & {
  handleFilterClick: (filter: Filter) => void;
  selectedFilter: Filter;
};

const Searchbar = ({
  onSelectGender,
  onSelectFilter,
  onSearch,
  filters,
  scrollY,
}: SearchBarProps) => {
  const { isMobile } = useMobile();
  const [selectedFilter, setSelectedFilter] = useState<Filter>(
    $filters.defaultModelFilter,
  );

  const handleFilterClick = (filter: Filter) => {
    setSelectedFilter(filter);
    onSelectFilter(filter);
  };

  return isMobile ? (
    <MobileSearchbar
      onSelectFilter={onSelectFilter}
      onSearch={onSearch}
      filters={filters}
      onSelectGender={onSelectGender}
      handleFilterClick={handleFilterClick}
      selectedFilter={selectedFilter}
      scrollY={scrollY}
    />
  ) : (
    <DesktopSearchbar
      onSelectFilter={onSelectFilter}
      onSearch={onSearch}
      filters={filters}
      onSelectGender={onSelectGender}
      handleFilterClick={handleFilterClick}
      selectedFilter={selectedFilter}
      scrollY={scrollY}
    />
  );
};

export default Searchbar;
